import {getCountries} from 'libphonenumber-js/core';
import libPhoneNumberMetadata from 'libphonenumber-js/max/metadata';
import type {PhoneNumberFieldProps} from './PhoneNumberField';
import {createViewConfig} from '@sail/engine';
const COUNTRIES = getCountries(libPhoneNumberMetadata);

export const PhoneNumberFieldConfig = createViewConfig({
  props: {} as PhoneNumberFieldProps,
  name: 'PhoneNumberField',
  flattens: true,
  defaults: {
    countryAllowlist: COUNTRIES,
    size: 'medium',
    defaultCountry: 'US',
  },
});
